import {throwError as observableThrowError, of as observableOf, Observable} from 'rxjs';

import {catchError, map, switchMap} from 'rxjs/operators';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';



import {ApiMessageService, MessageType} from '../../core/api-message.service';
import {SpringError} from '../model/spring-error.model';
import {Router} from '@angular/router';
import {ConfigService} from '../../core/config.service';

/**
 * Service contenente i principali servizi per interrogazione ace
 * Differente da common-service che gestisce sempre e solo oggetti di tipo Base
 */
export abstract class PrincipalService<T extends any> {

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService) {
  }

  protected _buildInstance(json: any): T {
    if (json) {
      const instance: T = this.buildInstance(json);
      return instance;
    }
    return null;
  }

  public abstract buildInstance(json: any): T;

  public abstract getModule(): string;

  public abstract getRoute(): string;

  public abstract getApiService(): string;

  public getRequestMapping(): string {
    return this.getApiService() + this.getApiPath();
  }

  public getApiPath(): string {
    return '/v' + this.getApiVersion() + '/' + this.getRoute();
  }

  public getApiVersion() {
    return 1;
  }

  /**
   * Get programmabile. Fornire il path relativo e i queryParams.
   * @param {string} relativePath
   * @param {HttpParams} params
   * @returns {Observable<any>}
   */
   public getArray(relativePath: string, params: HttpParams, customRequestMapping?: string): Observable<T[]> {

    const requestMapping = customRequestMapping ? customRequestMapping :  this.getRequestMapping();
    return this.configService.getApiBase()
      .pipe(
        switchMap((apiBase) => {

          return this.httpClient.get<T[]>(apiBase + requestMapping + relativePath,{params: params})
            .pipe(
              map( (result: T[]) => {
                const items: T[] = result.map((item) => {
                  const instance: T = this._buildInstance(item);
                  return instance;
                });
                return items;
              }),
              catchError((responseError: HttpErrorResponse) => {
                if (responseError.status === 204) {  // No Content
                  return observableOf(null);
                }
                const springError = new SpringError(responseError);
                this.apiMessageService.sendMessage(MessageType.ERROR, springError.getRestErrorMessage());
                return observableThrowError(responseError);
              })
            );
        })
      );
  }

  public pCheck(): Observable<boolean> {
    return this.performPCheck(null);
  }

  private performPCheck(path: string): Observable<boolean> {

    path = path ? path : '';

    const params = new HttpParams().set('path', this.getApiPath() + path);

    return this.configService.getApiBase().pipe(switchMap(apiBase => {
      return this.httpClient.get<boolean>(apiBase + '/ace-webapp/v1/pcheck',{params: params})
          .pipe(map(result => {
              return result;
           }),
           catchError(error => {
             return observableOf(null);
           })
          );
        })
      );
  }
}